/*
 * @copyright   Copyright (C) 2023 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */

import React from 'react';

const Comingsoon = () => {
  return (
    <div className="vh-100 bg-blue-9 login-page position-relative">
      <div className="row justify-content-center align-items-center h-100 ">Coming soon</div>
    </div>
  );
};

export default Comingsoon;
